export const activitiesTabs = [
  { id: 'adults', key: 'activities.tab1', icon: 'ri-user-line' },
  { id: 'kids', key: 'activities.tab2', icon: 'ri-user-smile-line' },
  { id: 'camp', key: 'activities.tab3', icon: 'ri-sun-line' },
  { id: 'coaching', key: 'activities.tab4', icon: 'ri-award-line' },
  { id: 'itf', key: 'activities.tab5', icon: 'ri-trophy-line' },
  { id: 'rental', key: 'activities.tab6', icon: 'ri-calendar-check-line' },
];

export const activitiesContent = {
  adults: {
    items: [
      'activities.adults.item1',
      'activities.adults.item2',
      'activities.adults.item3',
      'activities.adults.item4',
    ],
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20player%20in%20action%20on%20a%20beautiful%20clay%20court%20with%20golden%20sunset%20lighting%2C%20dynamic%20pose%20mid-swing%2C%20athletic%20body%2C%20sport%20photography%20style%2C%20warm%20golden%20and%20green%20tones%2C%20dramatic%20cinematic%20mood%2C%20depth%20of%20field&width=800&height=600&seq=adults-tennis-01&orientation=landscape',
  },
  kids: {
    items: [
      'activities.kids.item1',
      'activities.kids.item2',
      'activities.kids.item3',
      'activities.kids.item4',
    ],
    image: 'https://readdy.ai/api/search-image?query=Happy%20children%20playing%20tennis%20on%20a%20sunny%20outdoor%20court%2C%20young%20tennis%20players%20aged%207-12%20years%20old%2C%20colorful%20sportswear%2C%20bright%20natural%20daylight%2C%20green%20court%20surface%2C%20coach%20giving%20instructions%20in%20background%2C%20joyful%20atmosphere%2C%20sports%20photography&width=800&height=600&seq=kids-tennis-01&orientation=landscape',
  },
  camp: {
    sessions: ['activities.camp.session1', 'activities.camp.session2'],
    activities: [
      'activities.camp.activity1',
      'activities.camp.activity2',
      'activities.camp.activity3',
      'activities.camp.activity4',
      'activities.camp.activity5',
      'activities.camp.activity6',
    ],
    image: 'https://readdy.ai/api/search-image?query=Summer%20tennis%20camp%20with%20kids%20aged%205-16%20years%20old%20having%20fun%20on%20outdoor%20courts%2C%20group%20activities%20with%20colorful%20cones%20and%20equipment%2C%20bright%20sunshine%2C%20green%20tennis%20courts%2C%20coaches%20supervising%2C%20energetic%20vibrant%20mood%2C%20beautiful%20summer%20day&width=800&height=600&seq=camp-tennis-01&orientation=landscape',
  },
  coaching: {
    items: [
      'activities.coaching.item1',
      'activities.coaching.item2',
      'activities.coaching.item3',
      'activities.coaching.item4',
    ],
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20coach%20giving%20intensive%20training%20session%20to%20adult%20players%2C%20coach%20holding%20clipboard%20on%20court%20sideline%2C%20group%20of%20players%20listening%20attentively%2C%20tennis%20court%20background%20with%20net%2C%20professional%20sportswear%2C%20bright%20daylight%2C%20educational%20atmosphere&width=800&height=600&seq=coaching-tennis-01&orientation=landscape',
  },
  itf: {
    items: [
      'activities.itf.item1',
      'activities.itf.item2',
      'activities.itf.item3',
      'activities.itf.item4',
    ],
    image: 'https://readdy.ai/api/search-image?query=International%20junior%20tennis%20tournament%20with%20teenage%20players%20competing%20on%20a%20professional%20court%2C%20umpire%20chair%2C%20spectators%20in%20stands%2C%20intense%20match%20moment%2C%20championship%20atmosphere%2C%20green%20court%20and%20white%20lines%2C%20sports%20competition%20photography%2C%20dramatic%20lighting&width=800&height=600&seq=itf-tennis-01&orientation=landscape',
  },
  rental: {
    items: [
      'activities.rental.item1',
      'activities.rental.item2',
      'activities.rental.item3',
      'activities.rental.item4',
    ],
    image: 'https://readdy.ai/api/search-image?query=Empty%20pristine%20tennis%20court%20under%20bright%20sunlight%20with%20net%20and%20white%20lines%2C%20ready%20for%20booking%2C%20clean%20green%20surface%2C%20tennis%20balls%20on%20court%2C%20floodlight%20poles%20visible%2C%20modern%20sports%20facility%2C%20inviting%20atmosphere%2C%20wide%20angle%20professional%20photography&width=800&height=600&seq=rental-tennis-01&orientation=landscape',
  },
};